(function () {
  const SELECTOR = '[data-diggn-landing-story]';
  const DESKTOP_QUERY = '(min-width: 990px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function initialise(story) {
    if (story.dataset.landingStoryReady === 'true') return;

    const chapters = Array.from(story.querySelectorAll('[data-landing-story-chapter]'));
    const visuals = Array.from(story.querySelectorAll('[data-landing-story-visual]'));
    const counter = story.querySelector('[data-landing-story-counter]');
    if (!chapters.length || chapters.length !== visuals.length) return;

    let activeIndex = -1;
    let frameRequested = false;
    story.style.setProperty('--landing-story-count', String(chapters.length));

    function setActive(index) {
      const nextIndex = clamp(index, 0, chapters.length - 1);
      if (nextIndex === activeIndex) return;
      activeIndex = nextIndex;
      chapters.forEach((chapter, chapterIndex) => chapter.classList.toggle('is-active', chapterIndex === nextIndex));
      visuals.forEach((visual, visualIndex) => visual.classList.toggle('is-active', visualIndex === nextIndex));
      story.style.setProperty('--landing-story-index', String(nextIndex));
      if (counter) counter.textContent = String(nextIndex + 1).padStart(2, '0');
    }

    function update() {
      frameRequested = false;
      if (!window.matchMedia(DESKTOP_QUERY).matches || window.matchMedia(REDUCED_MOTION_QUERY).matches) {
        setActive(0);
        story.style.setProperty('--landing-story-progress', '0');
        return;
      }

      const focusLine = window.innerHeight * 0.52;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      chapters.forEach((chapter, index) => {
        const rect = chapter.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - focusLine);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      const activeRect = chapters[nearestIndex].getBoundingClientRect();
      const progress = clamp((focusLine - activeRect.top) / Math.max(activeRect.height, 1), 0, 1);
      setActive(nearestIndex);
      story.style.setProperty('--landing-story-progress', progress.toFixed(4));
    }

    function requestUpdate() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) requestUpdate();
      },
      { rootMargin: '35% 0px', threshold: 0 }
    );
    observer.observe(story);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    setActive(0);
    requestUpdate();
    story.dataset.landingStoryReady = 'true';
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
